import CmnBtnContainer from "../layout/components/CmnBtnContainer";

const Industries = () => {
  return (
    <div style={{ backgroundColor : "#F1F1EC"}}>
        <div style={{height : "100vh", justifyContent : "center"}} className="cmn-page-container">
            <img src="/svg/indus-container-bg.svg" className="indus-img-container" alt="bg1"/>
            <img src="/svg/indus-wrapper-bg.svg" className="indus-img-container" alt="bg2"/>
            <div style={{height : "100%", padding : "0 5em", flexDirection : "column", justifyContent : "center"}} className="page-content-wrapper">
                <div style={{justifyContent : "center", gap : "1.5em", alignItems : "center"}} className="content">
                    <p>Industries We Serve</p>
                    <CmnBtnContainer/>
                </div>
            </div>
        </div>
        <div id="time-line-container">
            <div id="time-line-wrapper">
                <img style={{position : "absolute", right : "0", top : "-5%"}} src="/svg/indus-time-line-r-sh.svg" alt="" height="30%" />
                <div className="time-line-row">
                    <div style={{order : 3, zIndex : "1",borderTopRightRadius : "222px", borderBottomRightRadius : "222px", opacity : "58%", position : "absolute", width : "45%", height : "100%", left : "0", top : "0", background: "linear-gradient(180.46deg, #D9D9D9 7.56%, #F0F1EC 90.08%)"}}></div>
                    <div className="content-card">
                        <div className="content-wrapper">
                            <div className="heading-line-wrapper">
                                <h2>Construction & Engineering</h2>
                                <span className="line"></span>
                            </div>
                            <p>Track field hours, manage job sites, and monitor project progress with precision.</p>
                        </div>
                        <div className="content-wrapper">
                            <div className="heading-line-wrapper">
                                <h2>Consulting & Agencies</h2>
                                <span className="line"></span>
                            </div>
                            <p>Ensure accurate client billing and track consultant time effectively.</p>
                        </div>
                    </div>
                    <div className="time-line-img-wrapper">
                        <img src="/svg/indus-tl-construct.svg" alt="Consulting & Agencies"/>
                    </div>
                </div>
                <div className="time-line-row">
                    <div className="content-card">
                        <div className="content-wrapper">
                            <div className="heading-line-wrapper">
                                <span className="line"></span>
                                <div className="content-card">
                                    <h2>Freelancers & Creatives</h2>
                                    <p>Manage multiple clients, track billable hours, and streamline invoicing.</p>
                                </div>
                            </div>
                        </div>
                        <div className="content-wrapper">
                            <div className="heading-line-wrapper">
                                <span className="line"></span>
                                <div className="content-card">
                                    <h2>Corporate Teams</h2>
                                    <p>Enhance workforce productivity with automated time tracking and insightful reports.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="time-line-img-wrapper">
                        <img id="bg-second" src="/svg/indus-tl-team.svg" alt="Freelancers & Creatives" />
                    </div>
                </div>
                <div className="time-line-row">
                    <div className="content-card">
                        <div className="content-wrapper">
                            <div className="heading-line-wrapper">
                                <h2>IT & Software Development</h2>
                                <span className="line"></span>
                            </div>
                            <p>Monitor developer hours, manage agile workflows, and ensure accurate project costing.</p>
                        </div>
                        <div className="content-wrapper">
                            <div className="heading-line-wrapper">
                                <h2>Healthcare & Legal Services</h2>
                                <span className="line"></span>
                            </div>
                            <p>Accurately track consultation hours and case-related work for billing and compliance.</p>
                        </div>
                    </div>
                    <div className="time-line-img-wrapper">
                        <img id="img-with-bg" src="/svg/indus-tl-sf-dev.svg" alt="IT & Software Development" />
                    </div>
                </div>
                <div className="time-line-row">
                    <div className="content-card">
                        <div className="content-wrapper">
                            <div className="heading-line-wrapper">
                                <span className="line"></span>
                                <div className="content-card">
                                    <h2>Education & Training</h2>
                                    <p>Track student participation, instructor hours, and course engagement efficiently.</p>
                                </div>
                            </div>
                        </div>
                        <div className="content-wrapper">
                            <div className="heading-line-wrapper">
                                <span className="line"></span>
                                <div className="content-card">
                                    <h2>Non-Profit & Volunteer Organizations</h2>
                                    <p>Ensure accountability and accurate tracking of volunteer hours for reporting and grant compliance.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="time-line-img-wrapper">
                        <img src="/svg/indus-tl-edu.svg" alt="Education & Training" />
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Industries;